export enum ActiveWebsitePage {
    Home = 'Home',
    FAQ = 'FAQ',
    AboutUs = 'AboutUs',
    Disclaimer = 'Disclaimer'
}